import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ToolbarButtonProps extends ButtonProps {
    /**
     * If true, applies the primary style (background color).
     * Typically used for "Save" or the main action.
     */
    isPrimary?: boolean;
}

/**
 * ToolbarButton - A standardized button for use in ActionToolbar and ContextualToolbar.
 * 
 * Features:
 * - Two distinct styles: Primary (Save) and Secondary (Others).
 * - Primary: Uses the theme's primary background.
 * - Secondary: Uses the theme's secondary background for a clean, integrated look.
 * - Default size is 'sm' for compactness.
 */
export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
    isPrimary,
    className,
    variant,
    size = "sm",
    children,
    ...props
}) => {
    return (
        <Button
            variant={variant || (isPrimary ? "default" : "ghost")}
            size={size}
            className={cn(
                "inline-flex items-center justify-center transition-colors font-bold",
                className
            )}
            {...props}
        >
            {children}
        </Button>
    );
};
